import { ErrorPayload } from "@ob/api/utils/safeFetch";
import { VendorStateType } from "@ob/layouts/VendorOnboarding/types";
import { createSelector } from "@reduxjs/toolkit";

export const selectBusinessFetching = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): boolean => vendor.kyb.sync.fetching,
);

export const selectBusinessError = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): ErrorPayload => vendor.kyb.sync.error,
);

export const selectBusinessSuccess = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): boolean => vendor.kyb.sync.success,
);
